function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { Component, memo } from 'react';
import PropTypes from 'prop-types';
import { useTheme, useValueFormatter } from '@nivo/core';

import "./ChartTooltip.scss";

var Tooltip = function (_Component) {
    _inherits(Tooltip, _Component);

    function Tooltip() {
        _classCallCheck(this, Tooltip);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Tooltip.prototype.render = function render() {
        var renderContent = this.props.renderContent;


        if (this.props.children) {

            return React.createElement(
                'article',
                { className: 'admin-tooltip' },
                this.props.children
            );
        } else if (typeof renderContent === 'function') {
            return renderContent();
        }

        return React.createElement(
            'article',
            { className: 'admin-tooltip' },
            JSON.stringify(this.props)
        );
    };

    return Tooltip;
}(Component);

export default Tooltip;

/*

const BasicTooltip = memo(({ id, value: _value, format, enableChip, color, renderContent }) => {
    const theme = useTheme()
    const formatValue = useValueFormatter(format)
    
    if (this.props.children) {
        return (
            <article className="admin-tooltip">
                { this.props.children }
            </article>
        )
    }

    let content
    if (typeof renderContent === 'function') {
        content = renderContent()
    } else {
        let value = _value
        if (formatValue !== undefined && value !== undefined) {
            value = formatValue(value)
        }
        content = (
            <div style={theme.tooltip.basic}>
                {value !== undefined ? (
                    <span>
                        {id}: <strong>{isNaN(value) ? String(value) : value}</strong>
                    </span>
                ) : (
                    id
                )}
            </div>
        )
    }

    return <div>{content}</div>
})

BasicTooltip.displayName = 'BasicTooltip'
BasicTooltip.propTypes = {
    id: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    enableChip: PropTypes.bool.isRequired,
    color: PropTypes.string,
    format: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    renderContent: PropTypes.func,
}
BasicTooltip.defaultProps = {
    enableChip: false,
}

export default BasicTooltip

*/